export default "__VITE_ASSET__hxw8$oqY__"